export default __webpack_public_path__ + "static/media/provesional_restoration_lower_26_2@2x.02dedb7f.png";